import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import history from "../store/history";
import user from './user';
import sites from './sites';
import consent from './consent';
import theme from './theme';
import dimensions from './dimensions';
import document_management from './document_management';

const appReducer = combineReducers({
  router: connectRouter(history),
  user,
  sites,
  consent,
  theme,
  dimensions,
  document_management,
});

const reducers = (state, action) => {
    //console.log("Action =========> ", action);
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'LOGOUT_SUCCESS') {
        state = undefined;
    }

    return appReducer(state, action)
};

export const persistedReducers = [user, document_management];

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js